import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../../../../components/Layout";
import EditMeetingContent from "../../../../../components/Pages/Vaadim/SinglePage/VaadTabs/MeetingsTab/FutureMeetingsTable/Edit";

const { displayName } = config;

export default function EditMeeting(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Edit Meetings`;
  }, []);

  return (
    <Layout>
      <EditMeetingContent />
    </Layout>
  );
}
